<div class="layout-map-view"><Header></Header><slot></slot></div>